<template>
 <div>
   <div v-if="videos.length > 0">
    <div class="embed-responsive embed-responsive-16by9">
      <div class="embed-responsive-item videoWrapper">
        <job-video-wrapper :entityList="videos" :jobId="jobId"></job-video-wrapper>
      </div>
    </div>
   </div>
   <div v-else-if="thumbs.length > 0">
     <b-carousel
      id="carousel-1"
      :interval="0"
      controls
      v-if="thumbs.length > 0">
      <b-carousel-slide v-for="url in thumbs" :key="url" :img-src="url" class="rounded-0" alt="Media Thumb" ></b-carousel-slide>
    </b-carousel>
   </div>
   <div v-else class="text-center pt-4 no-media">
     No Preview
   </div>
 </div>
</template>

<script>

import { entityThumbURLs, filterEntitiesByVideoOnly } from '#/models/entities/entity';
import { EntityGetSession } from '#/services/entities';
import JobVideoWrapper from '#/ui/Components/Jobs/JobVideoWrapper.vue';
import { EntityId } from '#/protobuf/entity_pb';

export default {
  components: {
    JobVideoWrapper,
  },
  props: {
    // entityIDs: {
    //   type: Array,
    //   required: true,
    // },
    job: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      entities: [],
      downloadURLs: [],
      jobId: '',
      entityIDs: [],
    };
  },
  created() {
    if (this.job) {
      this.jobId = this.job.jobId;
      this.entityIDs = this.getEntityIDs();
      console.log('created method', this.entityIDs);
      if (this.entityIDs.length > 0) {
        const session = new EntityGetSession(this.entityIDs);
        session.load().then((result) => {
          this.entities = result.toObject().entitiesList;
          console.log('loaded job media', this.entities);
          console.log('entities list', this.entities);
        }).catch((error) => {
          console.warn('caught error loading job media', error);
        });
      }
    }
  },
  computed: {
    name() {
      // properly make sure this stays as one row. and doesn't trigger overflow into a second row
      let name = this.entity.name ? this.entity.name : '(No Name)';
      if (name.length > 15) {
        name = `${name.substring(0, 15)}...`;
      }
      return name;
    },
    thumbs() {
      return entityThumbURLs(this.entities);
    },
    videos() {
      return filterEntitiesByVideoOnly(this.entities);
    },
  },
  methods: {
    openFile() {
      const path = `/files/${this.entity.size}/${this.entity.checksum}`;
      console.info('opening file:', path);
      this.$router.push(path);
    },
    getEntityIDs() {
      const derivs = this.job.expandedMediaDerivativesList;
      if (derivs.length === 0) {
        return;
      }
      console.log('derivs', derivs);
      const allIds = [];
      derivs.forEach((d) => {
        const { size } = d.output;
        const checksum = d.output.checksums.xxhash3128;
        console.log('calculated media deriv id:', size, checksum);
        const entityId = new EntityId();
        entityId.setSize(size);
        entityId.setChecksum(checksum);
        allIds.push(entityId);
      });
      return allIds;
    }
  },
};
</script>

<style scoped>

</style>
